import { render } from "./ProductSectionCreateComponent.vue?vue&type=template&id=28529dde"
import script from "./ProductSectionCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductSectionCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/productSections/ProductSectionCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28529dde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28529dde', __exports__)) {
    api.reload('28529dde', __exports__)
  }
  
  module.hot.accept("./ProductSectionCreateComponent.vue?vue&type=template&id=28529dde", () => {
    api.rerender('28529dde', render)
  })

}


export default __exports__